import { render } from "./GoogleCallback.vue?vue&type=template&id=0fc08b5e&scoped=true"
import script from "./GoogleCallback.vue?vue&type=script&lang=js"
export * from "./GoogleCallback.vue?vue&type=script&lang=js"

import "./GoogleCallback.vue?vue&type=style&index=0&id=0fc08b5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc08b5e"]])

export default __exports__